import { HTMLAttributes, PropsWithChildren } from 'react';
import { HeadingLevel, HeadingMapper } from '../../../lib/utils/HeadingMapper';
import { classes, ClassType } from '../../../lib/utils/cssUtils';
import styles from './PureHeading.module.scss';

export type PureHeadingProps = PropsWithChildren<{
  level: HeadingLevel;
  as?: HeadingLevel;
  className?: ClassType;
}> &
  HTMLAttributes<HTMLHeadingElement>;

const PureHeading = ({ level, as, className, children, ...rest }: PureHeadingProps) => {
  const headingClass = classes(className, as && styles[as]);

  return (
    <HeadingMapper {...rest} level={level} className={headingClass}>
      {children}
    </HeadingMapper>
  );
};

export default PureHeading;
